var symphony = symphony || {};

;
(function () {

    symphony.mapControl = {
        maps: [],
        defaults: {
            lat: 39.8283,
            lng: -98.5795,
            zoom: 4
        },

        init: function (id) {
            if (!navigator.geolocation) {
                $('#' + id + '-geocode').hide();
            }

            if (window.localStorage && localStorage.getItem('mapcontrol-search') !== null) {
                var savedSearch = JSON.parse(localStorage.getItem('mapcontrol-search'));
                $('#' + id).find('.mapControl-search').val(savedSearch.text);
                this.defaults.lat = savedSearch.lat;
                this.defaults.lng = savedSearch.lng;
                this.defaults.zoom = 12;

                // automatically kick off search
                this.search(id, savedSearch.text);
            }

            this.registerEvents(id);
            this.render(id);
        },

        registerEvents: function (id) {
            $('#' + id + '-search').keydown(function (e) {
                $('#' + id).find('.mapControl-error').hide();

                if (e.keyCode == 13) {
                    symphony.mapControl.search(id, $('#' + id + '-search').val().trim());
                }
            });
            $('#' + id + '-go').click(function () {
                $('#' + id).find('.mapControl-error').hide();

                symphony.mapControl.search(id, $('#' + id + '-search').val().trim());
            });

            if (UTIL) {
                var returnedFunction = UTIL.debounce(function (event) {
                    symphony.mapControl.render(id);
                }, 500);

                window.addEventListener('resize', returnedFunction);
            }
        },

        render: function (id) {

            var mapExists = $.grep(this.maps, function (x) {
                return x.id == id;
            }).length > 0;

            // if not mobile, render map
            if ($(window).width() >= 768) {
                if (!mapExists || document.body.classList.contains('admin-body')) {

                    // remove any existing matching maps
                    this.maps = $.grep(this.maps, function (x) {
                        return x.id != id;
                    });

                    if (window.localStorage && localStorage.getItem('mapcontrol-search') !== null) {
                        var savedSearch = JSON.parse(localStorage.getItem('mapcontrol-search'));
                        $('#' + id).find('.mapControl-search').val(savedSearch.text);
                        this.defaults.lat = savedSearch.lat;
                        this.defaults.lng = savedSearch.lng;
                        this.defaults.zoom = 12;

                        // automatically kick off search
                        this.search(id, savedSearch.text);
                    }

                    var map = new google.maps.Map($('#' + id).find('.mapControl')[0], {
                        center: {
                            lat: this.defaults.lat,
                            lng: this.defaults.lng
                        },
                        zoom: this.defaults.zoom,
                        mapTypeControl: false,
                        zoomControl: true,
                        zoomControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_BOTTOM
                        },
                        scaleControl: false,
                        streetViewControl: false
                    });

                    this.maps.push({
                        id: id,
                        map: map,
                        markers: []
                    });

                }
            } else {

                // remove any existing matching maps
                this.maps = $.grep(this.maps, function (x) {
                    return x.id != id;
                });

                if (mapExists) {
                    $('#' + id).find('.mapControl').html('');
                }
            }
        },

        useUsersLocation: function (id) {
            if (navigator.geolocation) {
                var nudge = $('#' + id).find('.mapControl-nudge')[0];

                var showNudgeBanner = function () {
                    nudge.style.display = "block";
                };

                var hideNudgeBanner = function () {
                    nudge.style.display = "none";
                };

                var nudgeTimeoutId = setTimeout(showNudgeBanner, 5000);

                var geoSuccess = function (position) {
                    hideNudgeBanner();
                    // We have the location, don't display banner
                    clearTimeout(nudgeTimeoutId);

                    // reverse geocode to get zip for search
                    $.ajax({
                        url: '//api.opencagedata.com/geocode/v1/json?q=' + position.coords.latitude + ',' + position.coords.longitude + '&key=' + openCageApiKey,
                        success: function (retVal) {
                            if (retVal.results.length > 0) {
                                var loc = retVal.results[0].components;
                                $('#' + id + '-search').val(loc.postcode);
                                symphony.mapControl.getResults(id, loc.postcode, position.coords.latitude, position.coords.longitude);
                            }
                        }
                    });
                };
                var geoError = function (error) {
                    switch (error.code) {
                        case error.TIMEOUT:
                            // The user didn't accept the callout
                            showNudgeBanner();
                            break;
                    }
                };

                $('#' + id).find('.mapControl-results').scrollTop(0)
                $('#' + id).find('.mapControl-results').addClass('local-loading');
                navigator.geolocation.getCurrentPosition(geoSuccess, geoError);

            } else {
                $('#' + id + '-geocode').hide();
            }
        },

        search: function (id, searchText) {
            var self = this;

            if (searchText.length > 0) {
                $('#' + id).find('.mapControl-results').scrollTop(0)
                $('#' + id).find('.mapControl-results').addClass('local-loading');
                // geocode search text
                $.ajax({
                    url: '//api.opencagedata.com/geocode/v1/json?q=' + searchText + '&countrycode=us&key=' + openCageApiKey,
                    success: function (retVal) {
                        var lat = null;
                        var lng = null;
                        if (retVal.results.length > 0) {

                            // if non-numeric search, loop through results to try and match city
                            // fixes issue of matching county first
                            if (isNaN(searchText)) {
                                for (var i = 0; i < retVal.results.length; i++) {
                                    if (lat == null || lng == null) {
                                        if (retVal.results[i] && retVal.results[i].components && retVal.results[i].components.city && searchText.toLowerCase().indexOf(retVal.results[i].components.city.toLowerCase()) > -1) {
                                            lat = retVal.results[i].geometry.lat;
                                            lng = retVal.results[i].geometry.lng;
                                        }
                                    }
                                }
                            }
                            if (lat == null || lng == null) {
                                lat = retVal.results[0].geometry.lat;
                                lng = retVal.results[0].geometry.lng;
                            }

                        }

                        if (lat == null || lng == null) {
                            $('#' + id).find('.mapControl-results').removeClass('local-loading');
                            $('#' + id).find('.mapControl-error').show();
                            return;
                        }

                        self.getResults(id, searchText, lat, lng);
                    }
                });

            } else {
                $('#' + id).find('.mapControl-error').show();
            }
        },

        newSearch: function (id) {
            $('#' + id).find('.mapControl-showingResults').hide();
            $('#' + id).find('.form-search').show();
            if (navigator.geolocation) {
                $('#' + id).find('.mapControl-geocode').show();
            }
        },

        getResults: function (id, searchText, lat, lng) {
            var self = this;

            // set showing results for... text
            $('#' + id).find('.mapControl-searchTerm').text(searchText);
            $('#' + id).find('.mapControl-showingResults').show();
            $('#' + id).find('.form-search').hide();
            $('#' + id).find('.mapControl-geocode').hide();

            // cache search for next load
            localStorage.setItem('mapcontrol-search', JSON.stringify({
                text: searchText,
                lat: lat,
                lng: lng
            }));

            if (document.body.classList.contains('admin-body')) {
                // if it's in admin, take a shortcut
                var propertyBuilderInfo = $('.admin--mapcontrol').mapControl('info');
                if (propertyBuilderInfo && propertyBuilderInfo.data && propertyBuilderInfo.data.objects) {
                    self.getClosest(id, propertyBuilderInfo.data, lat, lng);
                }
            } else {
                // otherwise, load the data
                $.get('/' + siteUrlAlias + '/json/properties', function (data) {
                    data = typeof data == "string" ? JSON.parse(data) : data;
                    var mapControlProps = $.grep(data.objects, function (o) {
                        return o.name == "mapcontrol";
                    });
                    var mapControlProp = mapControlProps[0];
                    for (var i = 0; i < mapControlProps.length; i++) {
                        mapControlProps[i].value = typeof mapControlProps[i].value == "string" ? JSON.parse(mapControlProps[i].value) : mapControlProps[i].value;
                        if (mapControlProps[i].value.id == id.replace('mapControl-', '')) {
                            mapControlProp = mapControlProps[i];
                        }
                    }

                    self.getClosest(id, mapControlProp && mapControlProp.value ? mapControlProp.value : {
                        objects: []
                    }, lat, lng);
                });

            }
        },

        getClosest: function (id, data, lat, lng) {
            var locations = data.objects;

            if (locations.length == 0) {
                $('#' + id).find('.mapControl-results').html('<span style="padding:25px; text-align:center; display:block;">Sorry, no results were found.<br />Please try a new search.</span>');
                $('#' + id).find('.mapControl-results').removeClass('mapControl-mobile-hasExtra');
                $('#' + id).find('.mapControl-results').removeClass('mapControl-mobile-showingExtra');
                return;
            }

            // make sure all lat/lng are numbers
            locations = $.grep(locations, function (x) {
                return !isNaN(x.lat) && !isNaN(x.lng) && x.active;
            });

            // get distance from center for each location
            for (var i = 0; i < locations.length; i++) {
                locations[i].lat = Number(locations[i].lat);
                locations[i].lng = Number(locations[i].lng);
                locations[i].distance = this.getDistance(lat, lng, locations[i].lat, locations[i].lng);
            }

            // sort closest to farthest
            locations.sort(function (a, b) {
                return a.distance > b.distance ? 1 : -1;
            });

            // limit results to 30
            locations = locations.slice(0, 30);

            // clear all the search results
            $('#' + id).find('.mapControl-results').html('');
            $('#' + id).find('.mapControl-results').removeClass('mapControl-mobile-hasExtra');
            $('#' + id).find('.mapControl-results').removeClass('mapControl-mobile-showingExtra');

            // get the map
            var currrentMap = $.grep(this.maps, function (x) {
                return x.id == id;
            })[0];

            // make sure map exists
            // it won't exist on mobile
            if (currrentMap) {
                //set map center to search lat/lng or first result
                currrentMap.map.panTo({
                    lat: locations.length > 0 ? locations[0].lat : lat,
                    lng: locations.length > 0 ? locations[0].lng : lng
                });
                currrentMap.map.setZoom(12);

                // clear all the markers
                for (var i = 0; i < currrentMap.markers.length; i++) {
                    currrentMap.markers[i].setMap(null);
                }
                currrentMap.markers = [];
            }

            // add new search results & markers
            _(locations).forEach(function (l, i) {
                $('#' + id).find('.mapControl-results').append(symphony.templates['property-mapcontrol-location']({
                    id: l.id,
                    url: l.url.trim(),
                    name: l.name,
                    html: l.html,
                    distance: l.distance.toFixed(1),
                    urlButtonText: data.urlButtonText || 'Give',
                    isExtra: i > 4
                }));

                if (currrentMap) {
                    var coords = {
                        lat: l.lat,
                        lng: l.lng
                    };
                    var m = new google.maps.Marker({
                        position: coords,
                        map: currrentMap.map,
                        title: l.name,
                        icon: {
                            size: new google.maps.Size(24, 32),
                            url: '/templates/usa_nhq_symphony/static_resources/images/global/location-pin.svg'
                        },
                        activeIcon: {
                            size: new google.maps.Size(24, 32),
                            icon: '/templates/usa_nhq_symphony/static_resources/images/global/location-pin-active.svg'
                        }
                    });

                    m.addListener('click', function () {
                        for (var i = 0; i < currrentMap.markers.length; i++) {
                            currrentMap.markers[i].setIcon('/templates/usa_nhq_symphony/static_resources/images/global/location-pin.svg');
                        }
                        this.setIcon('/templates/usa_nhq_symphony/static_resources/images/global/location-pin-active.svg');

                        $('#' + id).find('.mapControl-results div').removeClass('active');

                        $('#' + id).find('.mapControl-results div[data-id="' + l.id + '"]').addClass('active');

                        $('#' + id).find('.mapControl-results').animate({
                            scrollTop: $('#' + id).find('.mapControl-results div[data-id="' + l.id + '"]').position().top
                        });
                    });
                    currrentMap.markers.push(m);
                }
            });

            if (locations.length > 5) {
                $('#' + id).find('.mapControl-results').addClass('mapControl-mobile-hasExtra');
                $('#' + id).find('.mapControl-results').append('<a href="javascript:void(0)" onclick="symphony.mapControl.showExtra(\'' + id + '\')" class="mapControl-mobile-showExtra">Show more results</div>');
            }

            $('#' + id).find('.mapControl-results').removeClass('local-loading');
        },

        showExtra: function (id) {
            $('#' + id).find('.mapControl-results').addClass('mapControl-mobile-showingExtra');
        },

        getDistance: function (lat1, lon1, lat2, lon2) {
            var radlat1 = Math.PI * lat1 / 180;
            var radlat2 = Math.PI * lat2 / 180;
            var theta = lon1 - lon2;
            var radtheta = Math.PI * theta / 180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180 / Math.PI;
            dist = dist * 60 * 1.1515;
            return dist;
        }
    };

})();
